 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"application": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"application": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"pledge-against-antisemitism-countries":"pledge-against-antisemitism-countries","vendors~livecasts-stream":"vendors~livecasts-stream","livecasts-stream":"livecasts-stream","vendors~mena-list~speakers-bureau-presentations":"vendors~mena-list~speakers-bureau-presentations","mena-list":"mena-list","speakers-bureau-presentations":"speakers-bureau-presentations","admin-settings-panel":"admin-settings-panel","un-antisemitism-speakers":"un-antisemitism-speakers","un-antisemitism-stream":"un-antisemitism-stream","vendors~communities":"vendors~communities","communities":"communities","vendors~driver":"vendors~driver"}[chunkId]||chunkId) + "-" + {"0":"fc7b24532196c2f7699d","1":"f12f19d79359c222d652","2":"652f4065a18d07773a7f","3":"e10e64e47e4207fcda77","4":"fd27d13dbaa302de5287","6":"5e0f26583296e7eee9e4","7":"17a4d6a451f424044c15","9":"4b293b11569e508fb447","10":"df5bced97aeb0598c578","11":"9f0403e12cc2f0852d8d","12":"2e63c89fd153649263f7","13":"a9011815380f1ae64998","14":"1b8405aa82cd2aad4210","15":"d35892f130c5e3c7d988","16":"2e74f9572a46d233f815","17":"ff007b4f3799c67684c0","18":"2f3383723bab6e0cff11","19":"e5fdf3a6e23c56779d89","20":"39202d5a0c63f49fb176","21":"b9f2576fc18680628071","22":"71992f487a9a3e57639d","23":"ffe4624091cf2f1f7830","24":"5c11c8e2deaa03ea8a00","25":"5fcfba368d9fa4585988","26":"b9926bd8148f74aa047e","27":"b71d6bd892bf9a3e4e77","28":"41b998ea613a93b8b29f","29":"c194fb8fcd770710a67b","30":"f80c928f1491c325c6a0","31":"a67e6cd226c4ad9eadfe","32":"28fcc034eec24336a00c","33":"b0c97e98b0416906ba9c","34":"f3a6cfe2b2adad4867e5","35":"27295731fa80c54cfe13","36":"43c3117f5150c9b0272a","37":"b85a724abfc368371f3b","38":"0672051111c2ecfb99ae","39":"32fb869fbcb4131b5e15","40":"dd832a83f55ffa5297f5","41":"83697edc4966f9c8e4d5","42":"7bd30cedee5d9f0c71ed","43":"f2f04e07aa0750c4fcd2","44":"aabe6716a1df4182c44e","45":"0451499ce60b09dfeb4a","46":"0d136229215d8bb99ab2","47":"77f905d6646c8896a093","48":"bdd6c42cf3197e5158fe","49":"39aa5c6ee8340dccdf05","50":"bfe0691a44a91ffbd67f","51":"9e3fe1ca4f6b9a1c37f9","52":"16b55cb5bf341c0a74f3","53":"e1c2c7fdcd52565e566e","54":"9c986e937c64cad6b769","55":"d0a44322dbc5d103b26d","56":"bc265fa2f0bd82f2dedd","57":"5e7210862cde39278c95","58":"c424747028695be91869","59":"e089f95feea6648e5138","60":"6d91d34d433cc8f64fb0","61":"1719e80ca4d2e7981e33","62":"c42f48a87b00e1f57267","63":"3c8fc28d7e06503d869a","64":"91ec4bd7a335f83b6535","65":"7deb882d9ac9252879db","66":"96892d21312dddb7405b","67":"e0aca462b3eec42f625f","68":"c06192fdb37e6d142663","pledge-against-antisemitism-countries":"9c578d37a104bd2d8cc3","vendors~livecasts-stream":"976386b8856f6ba35684","livecasts-stream":"dd8db37e844272204d00","vendors~mena-list~speakers-bureau-presentations":"075fefeff9a52dcd9765","mena-list":"d4a91ea23fd273464a27","speakers-bureau-presentations":"4096ab344ba076b15bfb","admin-settings-panel":"fa3e45f4f0d378f082ee","un-antisemitism-speakers":"e862765dc89a25f261cf","un-antisemitism-stream":"1914d6efb93a21e9a9b6","vendors~communities":"07cf6082b122bc666aca","communities":"44687cb3c27882077ed4","vendors~driver":"63b569eb5a42464ca02e"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"6":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"22":1,"pledge-against-antisemitism-countries":1,"livecasts-stream":1,"mena-list":1,"speakers-bureau-presentations":1,"admin-settings-panel":1,"un-antisemitism-stream":1,"vendors~communities":1,"communities":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"pledge-against-antisemitism-countries":"pledge-against-antisemitism-countries","vendors~livecasts-stream":"vendors~livecasts-stream","livecasts-stream":"livecasts-stream","vendors~mena-list~speakers-bureau-presentations":"vendors~mena-list~speakers-bureau-presentations","mena-list":"mena-list","speakers-bureau-presentations":"speakers-bureau-presentations","admin-settings-panel":"admin-settings-panel","un-antisemitism-speakers":"un-antisemitism-speakers","un-antisemitism-stream":"un-antisemitism-stream","vendors~communities":"vendors~communities","communities":"communities","vendors~driver":"vendors~driver"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0","1":"31d6cfe0","2":"7ab1870d","3":"31d6cfe0","4":"31d6cfe0","6":"60af36da","7":"31d6cfe0","9":"c87a3e3a","10":"bf4160a1","11":"4a4dd0a4","12":"c5e44028","13":"506f619e","14":"c532b29a","15":"e662ff15","16":"65fc0669","17":"092e7423","18":"8918b2a1","19":"4a8d7013","20":"2a5d8ccf","21":"31d6cfe0","22":"14670fdc","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","pledge-against-antisemitism-countries":"eb3be7d4","vendors~livecasts-stream":"31d6cfe0","livecasts-stream":"36e8283f","vendors~mena-list~speakers-bureau-presentations":"31d6cfe0","mena-list":"f4a586b8","speakers-bureau-presentations":"5bc4d7f2","admin-settings-panel":"bce11854","un-antisemitism-speakers":"31d6cfe0","un-antisemitism-stream":"b714f8aa","vendors~communities":"132f9014","communities":"bdf3608d","vendors~driver":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://dxanokv0vp6kj.cloudfront.net/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "./app/javascript/packs/application.js");
